import { render, staticRenderFns } from "./InvoiceShipmentsModal.vue?vue&type=template&id=b9fc245a&"
import script from "./InvoiceShipmentsModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceShipmentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports